import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  topPanel?: ReactNode;
  leftPanel: ReactNode;
  rightPanel?: ReactNode;
  bottomPanel?: ReactNode;
  disabledMessage?: string;
  fullWidthLeftPanel?: boolean;
  // TODO: Eventually the left panel outline should be removed on everything, thus this prop and the style it controls should be removed from this component
  // The outline was a temporary style to help transition from the old input tables to the new design
  removeLeftPanelOutline?: boolean;
}

export const InputModalContentLayout = ({
  topPanel,
  leftPanel,
  rightPanel,
  bottomPanel,
  disabledMessage,
  fullWidthLeftPanel,
  removeLeftPanelOutline,
}: Props) => {
  const theme = useTheme();
  if (disabledMessage) {
    return (
      <Grid container columns={8} spacing={2}>
        <Grid size={{ xs: 5 }}>
          <Box
            sx={{
              backgroundColor: "grey.50",
              p: 3,
            }}
          >
            <Typography sx={{ color: theme.palette.text.secondary }}>
              {disabledMessage}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    );
  }
  // if we have a panel outline, it should enforce height by default
  return (
    <Stack spacing={2} height="100%">
      {topPanel}
      <Grid
        container
        columns={8}
        spacing={2}
        sx={{ flexShrink: 1, minHeight: 0 }}
      >
        <Grid
          size={{ xs: fullWidthLeftPanel ? 8 : 5 }}
          sx={{
            maxHeight: "100%",
            justifySelf: "center",
            border: removeLeftPanelOutline ? undefined : 1,
            borderRadius: 1,
          }}
        >
          {leftPanel}
        </Grid>
        <Grid size={{ xs: 3 }} sx={{ minHeight: 0, maxHeight: "100%" }}>
          {rightPanel}
        </Grid>
      </Grid>
      {bottomPanel}
    </Stack>
  );
};
